const appName = "Lifelink"

//Production URL

const baseURL = "https://linkplace.lifelink.co.th/api"
//const baseURL = "https://wp-linkplace.lifelink.co.th/api"
//const baseURL = "https://47.87.65.111/api"
//const baseURL = "https://203.151.190.236/api"
const wtc53109 = "https://wtc.co.th:53109"
const wtc5214 = "https://wtc.co.th:8082"
const visitor8082 = "https://visitor-api.lifelink.co.th:8082"


// Local URL
//const baseURL = "http://localhost:8080"
//const wtc53109 = "http://localhost:53109"
//const wtc5214 = "http://localhost:5214"

// Development URL
//const baseURL = "http://localhost:8080"

const oauth2ClientId = 'clientIdPassword'
const oauth2ClientSecret = 'secret'
const oauthPrefix = "Bearer" + " "

// Set to false in production
const isDevelopment = false

export { baseURL, oauth2ClientId, oauth2ClientSecret, oauthPrefix, isDevelopment, appName, wtc53109, wtc5214, visitor8082 }